import {useQuery} from '@tanstack/react-query';
import { getUnitsForSale, GSUParsedData, GUFSPayload } from '@services/new/community/getUnitsForSale';

const getUnitsForSaleQueryKey = (payload: GUFSPayload) => [
  'unitsForSale',
  payload,
];

const useUnitsForSale = (payload: GUFSPayload) => {
  return useQuery<GSUParsedData>({
    queryKey: getUnitsForSaleQueryKey(payload),
    queryFn: async () => await getUnitsForSale(payload).send(),
    staleTime: 1000 * 60 * 5,
  });
};

export default useUnitsForSale;

